import { render, staticRenderFns } from "./LearningSituation.vue?vue&type=template&id=15171eea&scoped=true&lang=pug&"
import script from "./LearningSituation.vue?vue&type=script&lang=ts&"
export * from "./LearningSituation.vue?vue&type=script&lang=ts&"
import style0 from "./LearningSituation.vue?vue&type=style&index=0&id=15171eea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15171eea",
  null
  
)

export default component.exports